var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',_vm._g({attrs:{"xmlns":"http://www.w3.org/2000/svg","width":"24","height":"24","viewBox":"0 0 24 24"}},_vm.$listeners),[_c('circle',{attrs:{"cx":"12","cy":"12","r":"2","fill":"currentColor","fill-opacity":".4"}})])}
var staticRenderFns = []

export { render, staticRenderFns }